import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EmailSubscriptionsTab from "../MyPreferences/EmailSubscriptionsTab";
import { useDynamicPageMeta } from "../../hooks/useDynamicPageMeta";
import type { MyEmailSubscriptionsResponse } from "../../Services/EmailUnsubscriber";

export default function StaffEmailSubscriptionsPage(): React.ReactElement {
  const { personId } = useParams<{ personId: string }>();
  const navigate = useNavigate();
  const { setPageMeta, clearPageMeta } = useDynamicPageMeta();
  const [personName, setPersonName] = useState<string>("");

  const handleLoaded = useCallback(
    (data: MyEmailSubscriptionsResponse | null) => {
      const name = (data?.personName ?? "").trim();
      setPersonName(name);
    },
    [],
  );

  const handleCancel = useCallback(() => {
    navigate("/unsubscribed-list");
  }, [navigate]);

  useEffect(() => {
    if (!personId) {
      return;
    }
    const label = personName || personId;
    setPageMeta({
      breadcrumbLabels: {
        [personId]: label,
      },
      title: personName
        ? `Email Subscriptions — ${personName}`
        : "Email Subscriptions",
    });
    return () => clearPageMeta();
  }, [personId, personName, setPageMeta, clearPageMeta]);

  if (!personId) {
    return (
      <main className="text-left px-6 lg:px-10 py-8">
        <p className="text-gray-font">Missing person id.</p>
      </main>
    );
  }

  return (
    <main className="text-left px-6 lg:px-10 py-8 lg:py-10 bg-white w-full">
      <h1 className="text-left text-secondary font-medium text-xl lg:text-3xl mb-6 font-decimal">
        {personName
          ? `Email Subscriptions — ${personName}`
          : "Email Subscriptions"}
      </h1>
      <EmailSubscriptionsTab
        variant="staff"
        personId={personId}
        onLoaded={handleLoaded}
        onCancel={handleCancel}
      />
    </main>
  );
}
